<template>
<div class="chapter">
<div class="inner_page">
<p class="sp1" id="pro"> </p>
<p class="CO"><span class="ePub-I">I used to like stories, especially the stories Mummy told me when I was little. </span>The Special Child<span class="ePub-I"> was best. It’s a bit of a babyish story for me now but I loved it the most back then. In </span>The Special Child<span class="ePub-I">, there’s a child that grows up all happy with a mummy and a daddy who are the king and the queen and then a wicked witch from the next kingdom comes and takes the Special Child into a prison and the mummy and the daddy are really sad but the Special Child does special fighting and kills the witch and escapes back to the mummy and daddy.</span></p>
<p class="TX"><span class="ePub-I">We used to do stories at school. Sometimes we had to read them. Other times we made them up. I remember I wrote down </span>The Special Child <span class="ePub-I">and did pictures.</span></p>
<p class="TX"><span class="ePub-I">Mummy used to say it was only a story but that sometimes stories come true. She said the wicked witch in </span>The Special Child<span class="ePub-I"> was only a lady in a story but that there were Bad People in real life too. She said you can’t tell from looking at them and that sometimes they will be smiley and saying all nice things and maybe offering sweets and toys but underneath they are still Bad People.</span></p>
<p class="TX"><span class="ePub-I">For a long time I never met any Bad People in real life – but then Ginger Tall and Broken Tooth happened and after that everything was different. Just like Mummy said.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// prologue.vue?9a912492